import { useState } from "react";
import "./NewQuoteTireCar.css";

/**
 *
 */
function NewQuoteTireCar() {
  const [selectedTireSize, setSelectedTireSize] = useState<string>("215/40 R19");
  const [inchUp, setInchUp] = useState<string>("選択サイズ");
  return (
    <div className="main-container">
      <div className="page-title">
        <h1>マスタ管理</h1>
        <h2>利用者一覧</h2>
      </div>
      <div className="car-selection-page">
        {/* 車種選択 */}
        <section className="car-selection">
          <h2>車種から選ぶ</h2>
          <div className="form-group">
            <label htmlFor="manufacturer">
              メーカー
              <input id="manufacturer" type="text" placeholder="メーカー名を入力" />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="carModel">
              車種名
              <input id="carModel" type="text" placeholder="車種名を入力" />
            </label>
          </div>
          <div className="car-preview">
            <img src="/images/car.png" alt="車のプレビュー" />
            <div className="car-info">
              <p>GR86 / 2021年〜現在</p>
              <div className="tire-size-options">
                <label htmlFor="tire-size-205-55R16">
                  205/55R16
                  <input
                    id="tire-size-205-55R16"
                    type="radio"
                    name="tire-size"
                    value="205/55R16"
                    className="align-radio"
                  />
                </label>
                <label htmlFor="tire-size-215-45R17">
                  215/45R17
                  <input
                    id="tire-size-215-45R17"
                    type="radio"
                    name="tire-size"
                    value="215/45R17"
                    className="align-radio"
                  />
                </label>
                <label htmlFor="tire-size-215-40R18">
                  215/40R18
                  <input
                    id="tire-size-215-40R18"
                    type="radio"
                    name="tire-size"
                    value="215/40R18"
                    className="align-radio"
                  />
                </label>
              </div>
            </div>
            <button type="button" className="select-button">
              選択する
            </button>
          </div>
        </section>

        {/* インチアップの指定 */}
        <section className="inch-up-selection">
          <h2>インチアップを指定します</h2>
          <div className="inch-up-buttons">
            <button
              type="button"
              className={inchUp === "選択サイズ" ? "active" : ""}
              onClick={() => setInchUp("選択サイズ")}
            >
              選択サイズ
            </button>
            <button
              type="button"
              className={inchUp === "1インチアップ" ? "active" : ""}
              onClick={() => setInchUp("1インチアップ")}
            >
              1インチアップを表示
            </button>
            <div className="tire-size-display">
              <label htmlFor="tire-size-215-40R19">
                <input
                  id="tire-size-215-40R19"
                  type="radio"
                  name="selected-tire-size"
                  value="215/40 R19"
                  checked={selectedTireSize === "215/40 R19"}
                  onChange={() => setSelectedTireSize("215/40 R19")}
                  className="align-radio"
                />
                215/40 R19
              </label>
            </div>
            <button
              type="button"
              className={inchUp === "2インチアップ" ? "active" : ""}
              onClick={() => setInchUp("2インチアップ")}
            >
              2インチアップを表示
            </button>
            <div className="tire-size-display">
              <label htmlFor="tire-size-215-35R20">
                <input
                  id="tire-size-215-35R20"
                  type="radio"
                  name="selected-tire-size"
                  value="215/35 R20"
                  checked={selectedTireSize === "215/35 R20"}
                  onChange={() => setSelectedTireSize("215/35 R20")}
                  className="align-radio"
                />
                215/35 R20
              </label>
            </div>
          </div>
          <button type="button" className="proceed-button">
            タイヤ選択へ進む
          </button>
        </section>

        {/* ホイールセット */}
        <section className="wheel-set-selection">
          <p>(ホイールセットの場合) どちらかを選択してください</p>
          <div className="wheel-set-buttons">
            <button type="button">タイヤから選ぶ</button>
            <button type="button">ホイールから選ぶ</button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default NewQuoteTireCar;
